export default __webpack_public_path__ + "img/c3a7c148cf1bb460c870fce85e5b1bc0.png";